// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Endpoint_endpointContainer__IUpz9 {
  display: grid;
  grid-template-columns: 15% 57% 28%;
  width: 100%;
  border-top: 1px solid #ededed;
}

.Endpoint_post__WO29m {
  margin: 1.6rem 0px 1.6rem 2.4rem;
  font-size: 1.4rem;
}

.Endpoint_endpointContents__g91SZ {
  margin: 2.4rem 3.2rem;
}

.Endpoint_endpointHeader__Fhmb8 {
  margin-bottom: 0.8rem;
}

.Endpoint_endpointName__xZKI\\+ {
  font-weight: bold;
  font-size: 1.6rem;
  padding-right: 0.8rem;
}

.Endpoint_schema__iyJac {
  font-size: 1.6rem;
  font-family: Inconsolata, Consolas, Courier, monospace;
  letter-spacing: -0.24px;
}

.Endpoint_endpointDescription__GF9Ah {
  font-size: 1.4rem;
  line-height: 1.6rem;
}

.Endpoint_buttonsContainer__lNsCI {
  display: flex;
  flex-direction: column;
}

.Endpoint_sendRequest__B8Rln {
  margin: 1.6rem 1.6rem 0.8rem 2.4rem;
  width: 70%;
}

.Endpoint_pdf__qT\\+jK {
  margin: 0 1.6rem 0 2.4rem;
  width: 70%;
}`, "",{"version":3,"sources":["webpack://./src/Components/Endpoint/index.module.scss","webpack://./node_modules/plaid-threads/scss/_variables.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,kCAAA;EACA,WAAA;EACA,6BAAA;AADF;;AAIA;EACE,gCAAA;EACA,iBAAA;AADF;;AAIA;EACE,qBAAA;AADF;;AAIA;EACE,qBCdK;ADaP;;AAIA;EACE,iBAAA;EACA,iBAAA;EACA,qBCpBK;ADmBP;;AAIA;EACE,iBAAA;EACA,sDCvBqB;EDwBrB,uBAAA;AADF;;AAIA;EACE,iBAAA;EACA,mBAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;AADF;;AAIA;EACE,mCAAA;EACA,UAAA;AADF;;AAIA;EACE,yBAAA;EACA,UAAA;AADF","sourcesContent":["@import \"~plaid-threads/scss/variables\";\n\n.endpointContainer {\n  display: grid;\n  grid-template-columns: 15% 57% 28%;\n  width: 100%;\n  border-top: 1px solid $black200;\n}\n\n.post {\n  margin: 2 * $unit 0px 2 * $unit 3 * $unit;\n  font-size: 1.4rem;\n}\n\n.endpointContents {\n  margin: 3 * $unit 4 * $unit;\n}\n\n.endpointHeader {\n  margin-bottom: $unit;\n}\n\n.endpointName {\n  font-weight: bold;\n  font-size: 2 * $unit;\n  padding-right: $unit;\n}\n\n.schema {\n  font-size: 2 * $unit;\n  font-family: $font-stack-monospace;\n  letter-spacing: -0.24px;\n}\n\n.endpointDescription {\n  font-size: 1.4rem;\n  line-height: 2 * $unit;\n}\n\n.buttonsContainer {\n  display: flex;\n  flex-direction: column;\n}\n\n.sendRequest {\n  margin: 2 * $unit 2 * $unit $unit 3 * $unit;\n  width: 70%;\n}\n\n.pdf {\n  margin: 0 2 * $unit 0 3 * $unit;\n  width: 70%;\n}\n","// All variables definitions belong here.\n// No variable definitions belong in component scss files\n@import 'colors';\n\n// base unit for all sizing, equivalent to 8px\n$unit: 0.8rem;\n\n$font-stack-monospace: Inconsolata, Consolas, Courier, monospace;\n$font-stack-sans: Cern, Helvetica, Arial, sans-serif;\n\n$font-size-large-form-controls: 2rem;\n$height-large-form-controls: 7 * $unit;\n\n// Animation\n$animation-primary-transition-timing-function: cubic-bezier(0.23, 1.2, 0.32, 1);\n$animation-secondary-transition-timing-function: ease-in-out;\n$animation-primary-transition-duration: 350ms;\n$animation-secondary-transition-duration: 100ms;\n$animation-primary: $animation-primary-transition-timing-function\n  $animation-primary-transition-duration;\n$animation-secondary: $animation-secondary-transition-timing-function\n  $animation-secondary-transition-duration;\n\n// Transitions\n$transition-duration: 35ms;\n$transition-delay-duration: 225ms;\n\n// Shadows\n$shadow-1: 0 ($unit * 2) ($unit * 3) 0 $color-box-shadow;\n$shadow-2: 0 $unit ($unit * 2) 0 $color-box-shadow;\n$shadow-3: 0 $unit $unit 0 $color-box-shadow;\n$shadow-4: 0 ($unit * 0.25) ($unit * 0.5) 0 $color-box-shadow;\n\n// deprecated, prefer shadow-1 etc\n$shadow-large: $shadow-1;\n$shadow-medium: $shadow-2;\n$shadow-small: $shadow-3;\n$shadow-xsmall: $shadow-4;\n\n// Stack Order\n$z-index-dropdown: 10;\n$z-index-tooltip: 100;\n$z-index-modal: 1000;\n$z-index-dateInput: 10000;\n\n// Borders\n$border-radius: 0.2rem;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"endpointContainer": `Endpoint_endpointContainer__IUpz9`,
	"post": `Endpoint_post__WO29m`,
	"endpointContents": `Endpoint_endpointContents__g91SZ`,
	"endpointHeader": `Endpoint_endpointHeader__Fhmb8`,
	"endpointName": `Endpoint_endpointName__xZKI+`,
	"schema": `Endpoint_schema__iyJac`,
	"endpointDescription": `Endpoint_endpointDescription__GF9Ah`,
	"buttonsContainer": `Endpoint_buttonsContainer__lNsCI`,
	"sendRequest": `Endpoint_sendRequest__B8Rln`,
	"pdf": `Endpoint_pdf__qT+jK`
};
export default ___CSS_LOADER_EXPORT___;
